import type { CreateInvoiceOrderDTO, OrderDTO } from 'ecosystem'
import { createEndpointError, fetchPropsFactory, storefrontApiCall } from '../../utils/fetching'
import { INVOICE_ORDERS_ENDPOINT } from './constants'

export async function createInvoiceOrder(payload: CreateInvoiceOrderDTO): Promise<OrderDTO> {
  const props = fetchPropsFactory({
    props: {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(payload)
    }
  })

  // Spec (`FEATURE_B2B_ORDER_PLACEMENT.md` §6) states the response is `OrderDTO`.
  // Observed BE behaviour today returns a slimmer shape (no `items`); treating
  // as `OrderDTO` until that's reconciled spec-side.
  const { data: order, error } = await storefrontApiCall<OrderDTO>(INVOICE_ORDERS_ENDPOINT, props)

  if (error || !order) {
    return createEndpointError('create invoice order')
  }

  return order
}
